import { Rect, StaticCanvas } from 'fabric';

/**
 * Clips rendering to the canvas frame so objects outside the export area are
 * not visible. Apply it after loading the JSON and setting the final dimensions.
 *
 * `absolutePositioned` anchors the clip path to the canvas coordinate system;
 * otherwise Fabric transforms it relative to the canvas contents. A zero-width
 * stroke also prevents a one-pixel bleed along the top and left edges.
 */
export function applyCanvasFrameClip(canvas: StaticCanvas, width: number, height: number): void {
  canvas.clipPath = new Rect({
    width,
    height,
    left: 0,
    top: 0,
    originX: 'left',
    originY: 'top',
    strokeWidth: 0,
    absolutePositioned: true
  });
}
